import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Switch,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface Campaign {
  messageCampaignId: any;
  messageCampaignName: string;
  lifetimeBudget: number;
  campaignStatus: boolean;
}

interface Props {
  campaigns: Campaign[];
  adAccountName: string;
  adAccountCurrency: string;
  onOpenMessages: (campaign: Campaign) => void;
}

const CampaignsList: React.FC<Props> = ({
  campaigns,
  adAccountName,
  adAccountCurrency,
  onOpenMessages,
}) => {
  if (campaigns.length === 0) {
    return (
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textAlign: "center", mt: 5 }}>
        No message campaigns are available.
      </Typography>
    );
  }

  return (
    <>
      {campaigns.map((campaign) => (
        <Card
          key={campaign.messageCampaignId}
          variant="outlined"
          sx={{
            borderRadius: 3,
            mb: 2,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
            "&:hover": {
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
            },
          }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "8px 0",
              }}>
              <Box flex={1} sx={{ textAlign: "start" }}>
                <Box display={"flex"} justifyContent={"space-between"}>
                  <Typography variant="h6" fontWeight={600}>
                    {campaign.messageCampaignName}
                  </Typography>

                  <Button
                    variant="contained"
                    onClick={() => onOpenMessages(campaign)}
                    sx={{
                      backgroundColor: "#1DA1F2",
                      textTransform: "none",
                      p: "0px 6px",
                      mr: 3,
                    }}>
                    Messages
                  </Button>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" gap={3}>
                <Switch checked={campaign.campaignStatus} size="medium" />
              </Box>
            </Box>

            {/* Accordion */}
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header">
                <Typography component="span">View Campaign Details</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ pt: 0, textAlign: "start" }}>
                <Typography variant="body2" color="text.secondary">
                  <strong>AdAccount Name:</strong> {adAccountName}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  <strong>Lifetime Budget:</strong>{" "}
                  {adAccountCurrency === "USD" ? "$" : "INR"}
                  {campaign.lifetimeBudget / 100}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default CampaignsList;
